export default __webpack_public_path__ + "static/media/PolymersImg.e5d1b883.jpg";